import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Backdrop,
  CircularProgress,
  Button,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import SendIcon from "@mui/icons-material/Send";
import swal from "sweetalert";
import { update_stock_processing } from "../../../../../../services/purchase_service";
import "./set_refuse_reason.css";

const Set_refuse_reason = ({ open_reason_modal,
   setOpen_reason_modal,conforme_products,
   non_conforme_products,request_code,setStockStatus }) => {
  const [reason, setReason] = useState("");
  const [errorText, setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const submitRefuseReason = async () => {
    if (!reason.trim()) {
      setErrorText("Veuillez entrer un motif de rejet.");
      return;
    }
   //  console.log(" Data before sending:", conforme_products, non_conforme_products);
  
    setWaiting(true);
  
    swal({
      title: "La commande est non conforme",
      text: "Voulez-vous confirmer la non-conformité de la commande ?",
      icon: "warning",
      buttons: true,
    }).then(async (isConfirm) => {
      if (isConfirm) {
        try {
         //  console.log("User confirmed the non-conformity of the order");
  
          const now = new Date();
          const conformity_date = now.toLocaleString("sv-SE", { timeZone: "UTC" }).replace("T", " ");
  
          //  Set conforme: true for conforme_products
          const updatedConformeProducts = conforme_products.map((product) => ({
            ...product,
            conforme: true,
          }));
  
          // Set conforme: false for non_conforme_products
          const updatedNonConformeProducts = non_conforme_products.map((product) => ({
            ...product,
            conforme: false,
          }));
  
          //Concatenation dans `products_taken`
          const updated_products_taken = [...updatedConformeProducts, ...updatedNonConformeProducts];
  
          const requestData = {
            request_code: request_code,
            conformity_date: conformity_date,
            status: "non conforme", 
            products_taken: updated_products_taken,
            non_conformity_reason: reason,
          };
  
          const response = await update_stock_processing(requestData);
          setStockStatus("non conforme");
         //  console.log(" Response:", response);
  
          swal("Commande non conforme enregistrée!", "Motif: " + reason, "success");
          setOpen_reason_modal(false);
          
  
        } catch (error) {
          console.error(" Error updating conformity status:", error.response);
        }
      }
    });

  };
  

  return (
    <Dialog fullWidth maxWidth="md" open={open_reason_modal} onClose={() => setOpen_reason_modal(false)}>
      <DialogTitle>Motif du rejet</DialogTitle>
      <DialogContent>
        {errorText && <p className="error">{errorText}</p>}
        <TextField
          label="Motif"
          variant="outlined"
          multiline
          minRows={4}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          fullWidth
          style={{ marginTop: "5px" }}
        />
        <Backdrop sx={{ color: "#fff", zIndex: 1301 }} open={waiting}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </DialogContent>

      <DialogActions>
      <div className='dialogBottom'>
        <div>
        <Button variant="contained" className={waiting?"submit_but cancel_but disabled_button":"submit_but cancel_but"} startIcon={<CancelIcon className="my_icon" />} onClick={()=>setOpen_reason_modal(null)} >
                  Annuler
              </Button>
              <Button variant="contained" className={waiting?"submit_but valide_but disabled_button":"submit_but valide_but"} startIcon={<SendIcon className="my_icon" />} onClick={submitRefuseReason} >
                  Envoyer
              </Button> 
              </div>
              </div>
      </DialogActions>
    </Dialog>
  );
};

export default Set_refuse_reason;
